export default __webpack_public_path__ + "static/media/switch.2fa9a3ed.png";